/* GIAW Theme — Main JavaScript */
(function() {
  'use strict';

  /* ── FORMAT MONEY ── */
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  /* ── PANELS / MODALS ── */
  window.openPanel = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  };
  window.closePanel = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };
  window.openModal = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  };
  window.closeModal = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };
  window.closeMob = function() {
    var el = document.getElementById('mob-nav');
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };

  /* ── TOAST ── */
  window.showToast = function(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.style.opacity = '1';
    clearTimeout(t._t);
    t._t = setTimeout(function() { t.style.opacity = '0'; }, 2400);
  };

  /* ── SIZE PICKER ── */
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('sz')) {
      var row = e.target.closest('.sizes-row');
      if (row) {
        row.querySelectorAll('.sz').forEach(function(b) { b.classList.remove('on'); });
        e.target.classList.add('on');
      }
    }
  });

  /* ── TIER DISCOUNT PROGRESS BAR (flat ₹ amounts) ── */
  var CD_TIERS = [
    { min: 0, off: 250 },
    { min: 3499, off: 500 },
    { min: 4499, off: 750 }
  ];

  function cdGetActiveOff(subtotal) {
    if (subtotal >= CD_TIERS[2].min) return CD_TIERS[2].off;
    if (subtotal >= CD_TIERS[1].min) return CD_TIERS[1].off;
    return CD_TIERS[0].off;
  }

  function buildBannerHtml() {
    return '<div class="cd-prepaid-banner">Extra ₹250 off on prepaid orders</div>';
  }

  function buildTierBarHtml(subtotalCents) {
    var subtotal = subtotalCents / 100;
    var fillPct = 0;
    var nextTier = null;

    if (subtotal >= CD_TIERS[2].min) {
      fillPct = 100;
      nextTier = null;
    } else if (subtotal >= CD_TIERS[1].min) {
      fillPct = 50 + ((subtotal - CD_TIERS[1].min) / (CD_TIERS[2].min - CD_TIERS[1].min)) * 50;
      nextTier = CD_TIERS[2];
    } else {
      fillPct = (subtotal / CD_TIERS[1].min) * 50;
      nextTier = CD_TIERS[1];
    }

    var msg;
    if (nextTier) {
      var remaining = Math.ceil(nextTier.min - subtotal);
      msg = 'Add ₹' + remaining.toLocaleString('en-IN') + ' more to unlock ₹' + nextTier.off + ' OFF';
    } else {
      msg = 'You have unlocked the maximum ₹750 OFF';
    }

    function nodeClass(tierMin) {
      return subtotal >= tierMin ? 'cd-node unlocked' : 'cd-node';
    }
    function nodeIcon(tierMin) {
      return subtotal >= tierMin ? '✓' : '₹';
    }

    var html = '';
    html += '<div class="cd-tier-wrap">';
    html += '<div class="cd-tier-content">';
    html += '<p class="cd-tier-msg">' + msg + '</p>';
    html += '<div class="cd-bar-track">';
    html += '<div class="cd-bar-fill" style="width:' + Math.min(fillPct, 100) + '%"></div>';
    html += '<div class="' + nodeClass(CD_TIERS[0].min) + '" id="cd-node-1"><i class="cd-node-icon">' + nodeIcon(CD_TIERS[0].min) + '</i></div>';
    html += '<div class="' + nodeClass(CD_TIERS[1].min) + '" id="cd-node-2"><i class="cd-node-icon">' + nodeIcon(CD_TIERS[1].min) + '</i></div>';
    html += '<div class="' + nodeClass(CD_TIERS[2].min) + '" id="cd-node-3"><i class="cd-node-icon">' + nodeIcon(CD_TIERS[2].min) + '</i></div>';
    html += '</div>';
    html += '<div class="cd-tier-labels"><span>Any order<br>₹250 OFF</span><span>₹3,499<br>₹500 OFF</span><span>₹4,499<br>₹750 OFF</span></div>';
    html += '</div>';
    html += '</div>';

    return html;
  }

  /* Cache the upsell HTML the first time it's read, instead of re-reading
     the <template id="cd-upsell-template"> from the DOM each time. That
     template lives inside #cart-body, and refreshCartPanel() below replaces
     #cart-body's whole innerHTML on every cart update — destroying the
     template along with everything else. */
  var cdUpsellHtmlCache = null;

  function cdGetUpsellHtml() {
    if (cdUpsellHtmlCache !== null) return cdUpsellHtmlCache;
    var tpl = document.getElementById('cd-upsell-template');
    cdUpsellHtmlCache = tpl ? tpl.innerHTML : '';
    return cdUpsellHtmlCache;
  }

  function cdFilterUpsellByCart(cartItems) {
    var cartProductIds = {};
    (cartItems || []).forEach(function(item) {
      cartProductIds[item.product_id] = true;
    });
    document.querySelectorAll('.cd-upsell-card[data-cd-card]').forEach(function(card) {
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      if (pid && cartProductIds[pid]) {
        card.style.display = 'none';
      }
    });
  }

  function cdMountInitialUpsell(cartItems) {
    var mount = document.getElementById('cd-upsell-mount');
    if (mount) {
      mount.outerHTML = cdGetUpsellHtml();
      cdShuffleUpsell();
      cdFilterUpsellByCart(cartItems);
    }
  }

  /* ── AJAX CART ── */
  window.addToCart = function(variantId, qty) {
    qty = qty || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      showToast((item.title || 'Item') + ' added to cart');
      updateCartBadge();
      refreshCartPanel();
      openPanel('cart-panel');
    })
    .catch(function() { showToast('Could not add to cart'); });
  };

  window.updateCartBadge = function() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-badge').forEach(function(b) {
        b.textContent = cart.item_count;
      });
    });
  };

  window.refreshCartPanel = function() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var body = document.getElementById('cart-body');
      if (!body) return;

      var upsellHtml = cdGetUpsellHtml();

      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<div class="cart-empty-msg">Your cart is empty</div>';
        return;
      }

      var html = buildBannerHtml();
      html += buildTierBarHtml(cart.total_price);

      cart.items.forEach(function(item) {
        var img = item.image ? '<img class="ci-thumb" src="' + item.image + '" alt="' + item.title + '" width="60" height="60" style="object-fit:cover;">' : '<div class="ci-thumb" style="background:#E8DDD0;width:60px;height:60px;"></div>';
        html += '<div class="cart-item">' +
          img +
          '<div>' +
            '<p class="ci-name">' + item.product_title + '</p>' +
            '<p class="ci-meta">' + (item.variant_title && item.variant_title !== 'Default Title' ? 'SIZE: ' + item.variant_title : '') + '</p>' +
            '<div class="qty-row">' +
              '<button class="qbtn" onclick="changeCartQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>' +
              '<span class="qnum">' + item.quantity + '</span>' +
              '<button class="qbtn" onclick="changeCartQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px">' +
            '<span class="ci-price">' + formatMoney(item.final_line_price) + '</span>' +
            '<button class="ci-del" onclick="changeCartQty(\'' + item.key + '\',0)">✕</button>' +
          '</div>' +
        '</div>';
      });

      html += upsellHtml;

      var activeOff = cdGetActiveOff(cart.total_price / 100);
      var discountedTotal = Math.max(0, cart.total_price - (activeOff * 100));

      html += '<div class="cart-footer">' +
        '<div class="cf-row"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<div class="cf-row"><span>Discount (₹' + activeOff + ' off)</span><span>-₹' + activeOff + '</span></div>' +
        '<div class="cf-total"><span>Total</span><span><span class="cf-total-was">' + formatMoney(cart.total_price) + '</span> ' + formatMoney(discountedTotal) + '</span></div>' +
        '<a href="/checkout" class="btn-filled" style="width:100%;margin-top:18px;text-align:center;display:block">Checkout</a>' +
      '</div>';

      body.innerHTML = html;
      cdFilterUpsellByCart(cart.items);
    })
    .catch(function() {
      var body = document.getElementById('cart-body');
      if (body) body.innerHTML = '<div class="cart-empty-msg">Could not load cart</div>';
    });
  };

  window.changeCartQty = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function() {
      updateCartBadge();
      refreshCartPanel();
    });
  };

  window.cdAddUpsellFromCard = function(btnEl) {
    var card = btnEl.closest('.cd-upsell-card');
    var sizeSelect = card ? card.querySelector('.cd-upsell-size') : null;
    var variantId = sizeSelect ? sizeSelect.value : btnEl.dataset.defaultVariant;
    if (!variantId) return;
    btnEl.disabled = true;
    var originalText = btnEl.textContent;
    btnEl.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function(res) { return res.json(); })
      .then(function() {
        updateCartBadge();
        refreshCartPanel();
        showToast('Added to cart');
      })
      .catch(function() {
        btnEl.textContent = originalText;
        btnEl.disabled = false;
      });
  };

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function() {
    updateCartBadge();
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      cdMountInitialUpsell(cart.items);
    }).catch(function() { cdMountInitialUpsell([]); });
  });

})();